import React, { useEffect, useState } from "react";
import { CalendarClock, MessageCircle, Phone, Check, X, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { toWaNumber } from "./ReplyPanel";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("ro-RO", { dateStyle: "medium", timeStyle: "short" }) : "");
const STATUS = {
  new: { label: "Nouă", cls: "bg-[#FFF4E5] text-[#A16207]" },
  confirmed: { label: "Confirmată", cls: "bg-[#E8F5EC] text-[#1F5D2D]" },
  done: { label: "Finalizată", cls: "bg-[#E6EAF0] text-[#002B7F]" },
  cancelled: { label: "Anulată", cls: "bg-[#FDECEC] text-[#A11]" },
};

export const Bookings = ({ http }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { http.get("/admin/bookings").then((r) => setRows(r.data)).catch(() => setRows([])); }, [http]);

  const setStatus = async (b, status) => {
    try {
      await http.patch(`/admin/bookings/${b.id}`, { status });
      setRows((r) => r.map((x) => (x.id === b.id ? { ...x, status } : x)));
      toast.success(`Programare ${STATUS[status].label.toLowerCase()}`);
    } catch { toast.error("Nu s-a putut actualiza."); }
  };

  const confirmText = (b) => encodeURIComponent(`Bună ${b.name.split(" ")[0]}, sunt Florin de la Marioway Benefits Consultancy. Confirm consultația inițială gratuită (15 min) pentru ${b.service || "cererea ta"} – ${b.preferred_time}. Dacă nu îți convine, spune-mi ce zi/oră preferi. Mulțumesc!`);

  if (rows === null) return <p className="text-[#4A4A4A]">Se încarcă…</p>;
  return (
    <div data-testid="admin-bookings">
      <p className="text-[13px] text-[#4A4A4A] mb-4">{rows.length} cereri de programare din chat</p>
      {rows.length === 0 && <p className="soft-card p-6 text-[#4A4A4A]">Nicio programare încă. Când un vizitator cere o programare în chat, apare aici.</p>}
      <div className="space-y-3">
        {rows.map((b) => {
          const wa = toWaNumber(b.phone);
          const st = STATUS[b.status] || STATUS.new;
          return (
            <article key={b.id} className="soft-card p-5" data-testid="admin-booking-row">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div>
                  <div className="font-display text-xl text-[#002B7F]">{b.name || "Fără nume"}</div>
                  <div className="text-[13px] text-[#4A4A4A] mt-1 flex flex-wrap gap-x-4 gap-y-1">
                    {b.phone && <a href={`tel:${b.phone}`} className="inline-flex items-center gap-1 hover:text-[#F37021]"><Phone size={13} /> {b.phone}</a>}
                    <span className="inline-flex items-center gap-1"><CalendarClock size={13} /> {b.preferred_time || "-"}</span>
                  </div>
                </div>
                <div className="text-right text-[12px] text-[#6B7280]">
                  <div>{fmt(b.created_at)}</div>
                  <span className={`inline-block mt-1 rounded-full px-2.5 py-1 text-[11px] font-bold ${st.cls}`} data-testid="booking-status">{st.label}</span>
                </div>
              </div>
              {b.service && <div className="mt-3 inline-block rounded-full bg-[#F5F7FA] border border-[#E6EAF0] px-3 py-1 text-[12px] font-semibold text-[#002B7F]">{b.service}</div>}
              {b.notes && <p className="mt-2 text-[13px] text-[#4A4A4A]">{b.notes}</p>}
              <div className="mt-4 flex flex-wrap gap-2">
                {wa && (
                  <a href={`https://wa.me/${wa}?text=${confirmText(b)}`} target="_blank" rel="noopener noreferrer" className="btn-orange text-[13px] px-4 py-2" data-testid="booking-whatsapp">
                    <MessageCircle size={14} /> Confirmă pe WhatsApp
                  </a>
                )}
                {b.status !== "confirmed" && <button type="button" onClick={() => setStatus(b, "confirmed")} className="btn-ghost text-[13px] px-3 py-2" data-testid="booking-confirm"><Check size={14} /> Marchează confirmată</button>}
                {b.status !== "done" && b.status !== "cancelled" && <button type="button" onClick={() => setStatus(b, "done")} className="btn-ghost text-[13px] px-3 py-2" data-testid="booking-done"><Check size={14} /> Finalizată</button>}
                {b.status !== "cancelled" ? (
                  <button type="button" onClick={() => setStatus(b, "cancelled")} className="text-[13px] font-semibold text-[#A11] px-2" data-testid="booking-cancel"><X size={14} className="inline mr-1" /> Anulează</button>
                ) : (
                  <button type="button" onClick={() => setStatus(b, "new")} className="text-[13px] font-semibold text-[#002B7F] px-2" data-testid="booking-reopen"><RotateCcw size={14} className="inline mr-1" /> Redeschide</button>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};
